import { createContext, useContext } from 'react';
import { noop } from 'es-toolkit';
import { type ColumnElementType, type LayoutType } from '../../types';

export type ExtendedLayouts = LayoutType | 'comparisonTableMobile';

interface Margins {
  left: number;
  right: number;
}

interface Breakpoints {
  overflows: boolean;
  isMediumBreakpoint: boolean;
  isSmallBreakpoint: boolean;
}

interface LayoutContextType {
  breakpoints: Breakpoints;
  layout: ExtendedLayouts;
  rowIndexes: Record<ColumnElementType, number>;
  rowsCount: number;
  snapCarouselMargins: Margins;
  setLayout: (layout: ExtendedLayouts) => void;
  checkIfCheckoutError: (id: string) => boolean;
  setCheckoutError: (id: string) => void;
}

export const defaultRowIndexes = {
  button: 0,
  features: 0,
  picture: 0,
  price: 0,
  title: 0
};

export const LayoutContext = createContext<LayoutContextType>({
  breakpoints: {
    overflows: false,
    isMediumBreakpoint: false,
    isSmallBreakpoint: false
  },
  layout: 'grid',
  setLayout: noop,
  snapCarouselMargins: { left: 0, right: 0 },
  rowIndexes: defaultRowIndexes,
  checkIfCheckoutError: () => false,
  setCheckoutError: () => {},
  rowsCount: 0
});

export const useLayout = () => {
  return useContext(LayoutContext);
};
